import { useCallback, useEffect, useState, useContext } from "react";
import { FilterContext } from "../FilterContextProvider";
import useApi from "../Api/Api";

const useAllProducts = (filterOverrides = {}) => {
  const {
    filterData: { artist_id },
  } = useContext(FilterContext);
  const api = useApi();
  const [activeFilter, setActiveFilter] = useState(false);
  const [allProducts, setAllProducts] = useState([]);
  const [categoryFilter, setCategoryFilter] = useState();
  const [searchFilter, setSearchFilter] = useState();

  const fetchProducts = useCallback(() => {
    let queryParams = {};
    if (categoryFilter) {
      queryParams.category_id = categoryFilter;
    }
    if (activeFilter) {
      queryParams.active = true;
    }
    if (searchFilter) {
      queryParams.query = searchFilter;
    }
    if (filterOverrides) {
      queryParams.active = filterOverrides;
    }
    const queryString = Object.keys(queryParams)
      .map((param) => `${param}=${queryParams[param]}`)
      .join("&");
    api.get(`/products/all?artist_id=${artist_id}&${queryString}`).then((r) => {
      setAllProducts(r.data);
    });
  }, [
    api,
    setAllProducts,
    artist_id,
    filterOverrides,
    activeFilter,
    categoryFilter,
    searchFilter,
  ]);

  useEffect(fetchProducts, [fetchProducts]);

  return {
    allProducts,
    fetchProducts,
    allProdsActiveFilter: activeFilter,
    setAllProdsActiveFilter: setActiveFilter,
    allProdsCategoryFilter: categoryFilter,
    setAllProdsCategoryFilter: setCategoryFilter,
    allProdsSearchFilter: searchFilter,
    setAllProdsSearchFilter: setSearchFilter,
    setAllProducts,
  };
};

export default useAllProducts;
